import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useParams,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Aboutus from "./views/Aboutus/Aboutus";
import WhoweareP from "./views/Whoweare/WhoweareP";
import AboutHerings from "./views/Whoweare/AboutHerings";
import HeringsteamPage from "./views/Heringsteam/HeringsteamPage";
import RpmSolution from "./views/RPM/RpmSolution";
import Healthcare from "./views/RPM/Healthcare";
import ClinicalResearch from "./views/RPM/ClinicalResearch";
import IRinformation from "./views/IR/IRinformation";

import Service from "./views/Service/Service";
import Research from "./views/Research/Research";
import Cts from "./views/CTS/Cts";
import News from "./views/News/News";
import NewsDetail from "./views/News/NewsDetail";

import Contactus from "./views/Contactus/Contactus";
import "./index.css";
import "./common.css";
import Main from "./views/Main/Main";
import HomeV2 from "./redesign/_v2/HomeV2";
import HomeV3 from "./views/Main/HomeV3";
import { MediaQueryContext, ThemeContext } from "./context";
import { useMediaQuery } from "@material-ui/core";
import PrivacyPolicy from "./views/Privacy/PrivacyPolicy";
import Ham from "./views/ham/Ham";

import ScrollReveal from "./common/ScrollReveal";
import "./i18n";
import { DEFAULT_LANG, SUPPORTED_LANGS } from "./i18n";

export const imsi = `https://back.heringsglobal.com`; // 운영계
// export const imsi = `http://52.79.120.20:9099`; // 개발계
// export const imsi = `http://localhost:9099`; // local

const STORAGE_KEY = "lang";

const detectInitialLang = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  } catch (e) {}
  if (typeof navigator !== "undefined" && navigator.language) {
    const browser = navigator.language.toLowerCase();
    if (browser.startsWith("ko")) return "kr";
    if (browser.startsWith("en")) return "en";
  }
  return DEFAULT_LANG;
};

const LangSync = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (SUPPORTED_LANGS.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      try {
        localStorage.setItem(STORAGE_KEY, lang);
      } catch (e) {}
    }
  }, [lang, i18n]);
  return children;
};

const LangRoutes = ({ match }) => {
  const base = match.path; // "/:lang(kr|en)"
  return (
    <LangSync>
      <Switch>
        <Route exact path={`${base}/`} component={HomeV3} />
        <Route exact path={`${base}/v1`} component={Main} />
        <Route exact path={`${base}/v2`} component={HomeV2} />
        <Route exact path={`${base}/v3`} component={HomeV3} />
        <Route path={`${base}/about`} component={AboutHerings} />
        <Route path={`${base}/whoweare`} component={WhoweareP} />
        <Route path={`${base}/heringsteam`} component={HeringsteamPage} />
        <Route path={`${base}/aboutus/:submenu`} component={Aboutus} />
        <Route path={`${base}/aboutus`} component={Aboutus} />
        <Route path={`${base}/rpmsolution/:submenu`} component={RpmSolution} />
        <Route path={`${base}/rpmsolution`} component={RpmSolution} />
        <Route path={`${base}/healthcare`} component={Healthcare} />
        <Route path={`${base}/clinicalresearch`} component={ClinicalResearch} />
        <Route path={`${base}/irinformation/:submenu`} component={IRinformation} />
        <Route path={`${base}/irinformation`} component={IRinformation} />
        <Route path={`${base}/service/:submenu`} component={Service} />
        <Route path={`${base}/service`} component={Service} />
        <Route path={`${base}/research`} component={Research} />
        <Route path={`${base}/cts`} component={Cts} />
        <Route path={`${base}/contactus/:submenu`} component={Contactus} />
        <Route path={`${base}/contactus`} component={Contactus} />
        <Route exact path={`${base}/news`} component={News} />
        <Route path={`${base}/news/:id`} component={NewsDetail} />
        <Route path={`${base}/privacypolicy/`} exact component={PrivacyPolicy} />
        <Route path={`${base}/privacypolicy/:submenu`} component={PrivacyPolicy} />
        <Route path={`${base}/ham`} component={Ham} />
        <Route path="*" component={Aboutus} />
      </Switch>
    </LangSync>
  );
};

const LegacyRedirect = () => {
  const location = useLocation();
  const lang = detectInitialLang();
  const target = location.pathname === "/" ? `/${lang}` : `/${lang}${location.pathname}`;
  return <Redirect to={target + (location.search || "") + (location.hash || "")} />;
};

const App = () => {
  const cookietheme = localStorage.getItem("theme");
  if (!cookietheme) {
    localStorage.setItem("theme", "light");
  }
  const [theme, setTheme] = useState(cookietheme ? cookietheme : "light");
  const changeTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
    localStorage.setItem("theme", theme === "light" ? "dark" : "light");
  };

  const mobile = useMediaQuery("(min-width: 320px) and (max-width:600px)");
  const sTablet = useMediaQuery("(max-width:600px)");
  const mTablet = useMediaQuery("(max-width: 768px)");
  const sDesktop = useMediaQuery("(max-width: 1024px)");
  const mDesktop = useMediaQuery("(max-width: 1260px)");
  const lDesktop = useMediaQuery("(max-width: 1920px)");
  document.body.style.backgroundColor =
    theme === "dark" ? "#282828" : "#FFFFFF";

  return (
    <BrowserRouter>
      <ThemeContext.Provider value={{ theme, changeTheme }}>
        <MediaQueryContext.Provider
          value={{ mobile, sTablet, mTablet, sDesktop, mDesktop, lDesktop }}
        >
          <ScrollReveal />
          <Switch>
            <Route path="/:lang(kr|en)" component={LangRoutes} />
            <Route path="*" component={LegacyRedirect} />
          </Switch>
        </MediaQueryContext.Provider>
      </ThemeContext.Provider>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
